"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _PickupAddressTable = _interopRequireDefault(require("./PickupAddressTable.vue"));
var PickupAddress = /*#__PURE__*/function (_Vue) {
  function PickupAddress() {
    var _this;
    (0, _classCallCheck2.default)(this, PickupAddress);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, PickupAddress, [].concat(args));
    (0, _defineProperty2.default)(_this, "tabname", "GHTK");
    return _this;
  }
  (0, _inherits2.default)(PickupAddress, _Vue);
  return (0, _createClass2.default)(PickupAddress);
}(_vuePropertyDecorator.Vue);
PickupAddress = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    PickupAddressTable: _PickupAddressTable.default
  }
})], PickupAddress);
var _default = exports.default = PickupAddress;